import axios from "../utils/axiosConfig";
import { API_URL } from "../variables";
import { toast } from "react-toastify";

const WISHLIST_FETCH_REQUEST = "WISHLIST_FETCH_REQUEST";
const WISHLIST_FETCH_SUCCESS = "WISHLIST_FETCH_SUCCESS";
const WISHLIST_FETCH_FAIL = "WISHLIST_FETCH_FAIL";

const WISHLIST_ADD_REQUEST = "WISHLIST_ADD_REQUEST";
const WISHLIST_ADD_SUCCESS = "WISHLIST_ADD_SUCCESS";
const WISHLIST_ADD_FAIL = "WISHLIST_ADD_FAIL";

const WISHLIST_DELETE_REQUEST = "WISHLIST_DELETE_REQUEST";
const WISHLIST_DELETE_SUCCESS = "WISHLIST_DELETE_SUCCESS";
const WISHLIST_DELETE_FAIL = "WISHLIST_DELETE_FAIL";

export const fetchWishlist =
  (page = 1) =>
  async (dispatch, getState) => {
    const {
      auth: { token },
    } = getState();
    const config = { headers: { Authorization: token } };
    try {
      dispatch({ type: WISHLIST_FETCH_REQUEST });
      const { data } = await axios.post(
        `${API_URL}/api/products/wishlist`,
        { page, pagination: 10000 },
        config
      );
      dispatch({ type: WISHLIST_FETCH_SUCCESS, payload: data });
    } catch (error) {
      dispatch({
        type: WISHLIST_FETCH_FAIL,
        payload: error.response?.data?.message || error.message,
      });
    }
  };

export const addToWishlist = (product_id) => async (dispatch, getState) => {
  const {
    auth: { token },
  } = getState();
  const config = { headers: { Authorization: token } };

  dispatch({ type: WISHLIST_ADD_REQUEST });

  try {
    await axios.post(
      `${API_URL}/api/products/wishlist/add`,
      { product_id },
      config
    );
    toast.success("Item added to wishlist!");
    dispatch({ type: WISHLIST_ADD_SUCCESS, payload: product_id });
    return { isAlreadyInWishlist: false };
  } catch (error) {
    const errorMessage =
      error.response?.data?.message || "Failed to add item to wishlist";
    dispatch({ type: WISHLIST_ADD_FAIL, error: errorMessage });
    const isAlreadyInWishlist = errorMessage === "Product already in wishlist";
    return { isAlreadyInWishlist: isAlreadyInWishlist };
  }
};

export const deleteFromWishlist =
  (wishlist_id) => async (dispatch, getState) => {
    const {
      auth: { token },
    } = getState();
    const config = { headers: { Authorization: token } };
    try {
      dispatch({ type: WISHLIST_DELETE_REQUEST });
      await axios.post(
        `${API_URL}/api/products/wishlist/delete`,
        { wishlist_id },
        config
      );
      dispatch({ type: WISHLIST_DELETE_SUCCESS, payload: wishlist_id });
    } catch (error) {
      dispatch({
        type: WISHLIST_DELETE_FAIL,
        payload: error.response?.data?.message || error.message,
      });
    }
  };
